// Utilities
import { lazy } from "react";
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
export const RenamePlanDialogContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-renameplandialogcontainer" */ "./RenamePlanDialogContainer")).then((bundle)=>{
        return {
            default: bundle.RenamePlanDialogContainer
        };
    });
export const LazyRenamePlanDialogContainer = /*#__PURE__*/ lazy(RenamePlanDialogContainerLazyLoader);
